export default __webpack_public_path__ + "locales/ro/People.json?hash=6b04cbb10d9a7ec34c75679aaa7beee6";